import { describeErrorForLog } from '@cf-shared/error-describe';

/** The one report `runPostBrowserNavCallbacks` sends. Typed narrowly so this file needs no Angular. */
export interface DeferredCallbackReporter {
  trackSilentProblem(name: string, context: unknown): void;
}

/**
 * Run the callbacks NavController deferred until a browser-initiated navigation finished.
 *
 * One callback that throws must not stop the ones after it, so each runs in its own try.
 * A throw is reported as a silent problem as well as logged: the realistic one is the
 * deferred browser-history write for a pushed page, and when that fails the browser is left
 * one history entry short, so the back button seems to do nothing. A console line alone
 * leaves no trace of that in production (df-ece54bc08973).
 *
 * `reporter` is undefined until NavController.setLogger runs during app init; the console
 * line is still written then.
 */
export function runPostBrowserNavCallbacks(
  callbacks: readonly (() => void)[],
  reporter: DeferredCallbackReporter | undefined,
): void {
  for (const cb of callbacks) {
    try {
      cb();
    } catch (e) {
      console.error('NavController: deferred callback error:', e);
      reporter?.trackSilentProblem('NavDeferredCallbackThrew', { error: describeErrorForLog(e) });
    }
  }
}
